import { cn } from "@/lib/utils";

export const ASPECT_LABEL = { auto: "Match original", "1:1": "Square", "16:9": "Landscape", "9:16": "Portrait" };
const SHAPE = { auto: "h-3 w-3 border-dashed", "1:1": "h-3 w-3", "16:9": "h-2.5 w-4", "9:16": "h-4 w-2.5" };

export function AspectPicker({ options, value, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" role="radiogroup" aria-label="Shape" data-testid="aspect-picker">
      {options.map((a) => (
        <button key={a} type="button" role="radio" aria-checked={value === a} onClick={() => onChange(a)} data-testid={`aspect-${a.replace(":", "-")}`}
          className={cn("flex h-8 items-center gap-2 rounded-full px-3 text-xs transition-colors duration-200",
            value === a ? "bg-white/15 text-white" : "text-zinc-500 hover:bg-white/[0.05] hover:text-zinc-200")}>
          <span className={cn("rounded-[3px] border border-current", SHAPE[a])} />
          {ASPECT_LABEL[a]}
        </button>
      ))}
    </div>
  );
}
